import * as moment from 'moment'

export default {
	nameTheDate: function (date, format = 'DD.MM.YYYY') {
		if (!date) return '&nbsp;'
		moment.locale('cs')
		const today = moment().format(format)
		switch (true) {
		case date === today:
			return 'Dnes'
		case date === moment(today, format).add(1, 'days').format(format):
			return 'Zítra'
		case date === moment(today, format).add(2, 'days').format(format):
			return 'Pozítří'
		default:
			return moment(date, format).format('dddd')
		}
	}
}



// WEBPACK FOOTER //
// ./src/libs/helpers.js